import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"javascript:void(0);\">SmartAdmin</a></li><li class=\"breadcrumb-item\">Category</li><li class=\"breadcrumb-item\">Sub-category</li><li class=\"breadcrumb-item active\">Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\"><span class=\"js-get-date\"></span></li></ol><div class=\"subheader\"><h1 class=\"subheader-title\"><i class=\"subheader-icon fal fa-globe\"></i> Modal <span class=\"fw-300\">サンプル</span><sup class=\"badge badge-primary fw-500\">STICKER</sup><small> Insert page description or punch line </small></h1><div class=\"subheader-block\">Right Subheader Block</div></div><div class=\"alert alert-primary\"><div class=\"d-flex flex-start w-100\"><div class=\"mr-2 hidden-md-down\"><span class=\"icon-stack icon-stack-lg\"><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\"></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\"></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\"></i></span></div><div class=\"d-flex flex-fill\"><div class=\"flex-fill\"><span class=\"h5\">注意事項!</span><p>特に注意事項はないです</p><p class=\"m-0\"> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\">Call to action &gt;&gt;</a></p></div></div></div></div>", 3)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr\"><h2>modal</h2><div class=\"panel-toolbar\"><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-close\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Close\"></button></div></div>", 1)
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = { class: "panel-content" }
const _hoisted_11 = { class: "frame-wrap" }
const _hoisted_12 = { class: "demo" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " 各モーダルはコンポーネント化している ", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr\"><h2>modal-left</h2><div class=\"panel-toolbar\"><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-close\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Close\"></button></div></div>", 1)
const _hoisted_18 = { class: "panel-container show" }
const _hoisted_19 = { class: "panel-content" }
const _hoisted_20 = { class: "frame-wrap" }
const _hoisted_21 = { class: "demo" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " 各モーダルはコンポーネント化している ", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr\"><h2>modal-alert</h2><div class=\"panel-toolbar\"><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-close\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Close\"></button></div></div>", 1)
const _hoisted_27 = { class: "panel-container show" }
const _hoisted_28 = { class: "panel-content" }
const _hoisted_29 = { class: "frame-wrap" }
const _hoisted_30 = { class: "demo" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " 各モーダルはコンポーネント化している ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-3" }, [
    /*#__PURE__*/_createElementVNode("h5", null, [
      /*#__PURE__*/_createTextVNode(" ADP System Migration "),
      /*#__PURE__*/_createElementVNode("small", { class: "mt-0 mb-3 text-muted" }, " Migration of new API to local servers "),
      /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary fw-n position-absolute pos-top pos-right mt-3 mr-3" }, "A")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "row fs-b fw-300" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col text-left" }, "Progress"),
      /*#__PURE__*/_createElementVNode("div", { class: "col text-right" }, "90%")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs d-flex mb-2 mt-1" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "progress-bar bg-primary-500 progress-bar-striped",
        role: "progressbar",
        style: {"width":"90%"},
        "aria-valuenow": "90",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-300 mb-0" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col" }, "Budget"),
        /*#__PURE__*/_createElementVNode("div", { class: "col text-right" }, "$1,325,987.30")
      ])
    ])
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-g" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-3" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-danger" }, [
      /*#__PURE__*/_createTextVNode(" ADP System Migration "),
      /*#__PURE__*/_createElementVNode("small", { class: "mt-0 mb-3 text-muted" }, " Migration of new API to local servers "),
      /*#__PURE__*/_createElementVNode("span", { class: "badge badge-danger fw-n position-absolute pos-top pos-right mt-3 mr-3" }, "Delayed")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "row fs-b fw-300" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col text-left" }, "Progress"),
      /*#__PURE__*/_createElementVNode("div", { class: "col text-right" }, "26%")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs d-flex mb-2 mt-1" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "progress-bar bg-danger-500 progress-bar-striped",
        role: "progressbar",
        style: {"width":"26%"},
        "aria-valuenow": "26",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-300 mb-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col" }, "Budget"),
        /*#__PURE__*/_createElementVNode("div", { class: "col text-right text-danger" }, "-$155,473.70")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-xs mb-3 fw-300" }, [
      /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled mb-1" }, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("i", { class: "fal fa-circle text-muted" }),
          /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, [
            /*#__PURE__*/_createElementVNode("s", null, " Heated maps generated")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("i", { class: "fal fa-circle text-danger" }),
          /*#__PURE__*/_createTextVNode(" Turncated syndicate rated ")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("i", { class: "fal fa-dot-circle text-danger" }),
          /*#__PURE__*/_createTextVNode(" ADP forms needs approval and review ")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle text-danger" }),
          /*#__PURE__*/_createTextVNode(" Bug review ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "text-left fw-400" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-secondary mb-1" }, "Project Owners"),
      /*#__PURE__*/_createElementVNode("div", { class: "fs-sm d-flex align-items-center" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "img/demo/avatars/avatar-a.png",
            class: "profile-image-sm rounded-circle",
            alt: "aa"
          })
        ]),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "img/demo/avatars/avatar-b.png",
            class: "profile-image-sm rounded-circle",
            alt: "aa"
          })
        ]),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "img/demo/avatars/avatar-c.png",
            class: "profile-image-sm rounded-circle",
            alt: "aa"
          })
        ]),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "img/demo/avatars/avatar-e.png",
            class: "profile-image-sm rounded-circle",
            alt: "aa"
          })
        ]),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "img/demo/avatars/avatar-h.png",
            class: "profile-image-sm rounded-circle",
            alt: "aa"
          })
        ]),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: "img/demo/avatars/avatar-k.png",
            class: "profile-image-sm rounded-circle",
            alt: "aa"
          })
        ]),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn-m-s fs-xs"
        }, [
          /*#__PURE__*/_createElementVNode("span", {
            "data-hasmore": "+7",
            class: "rounded-circle profile-image-sm"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: "img/demo/avatars/avatar-j.png",
              class: "profile-image-sm rounded-circle",
              alt: "aa"
            })
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-g" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-3" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-success" }, [
      /*#__PURE__*/_createTextVNode(" ADP System Migration "),
      /*#__PURE__*/_createElementVNode("small", { class: "mt-0 mb-3 text-muted" }, " Migration of new API to local servers "),
      /*#__PURE__*/_createElementVNode("span", { class: "badge badge-success fw-n position-absolute pos-top pos-right mt-3 mr-3" }, "D")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "row fs-b fw-300 text-secondar" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col text-left" }, "COMPLETE")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs d-flex mb-2 mt-1" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "progress-bar bg-success-500 progress-bar-striped",
        role: "progressbar",
        style: {"width":"100%"},
        "aria-valuenow": "100",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fw-300 mb-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col" }, "Budget"),
        /*#__PURE__*/_createElementVNode("div", { class: "col text-right" }, "$134")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col text-right" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn btn-default btn-sm waves-effect waves-themed"
        }, "APPROVE"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "btn btn-default btn-sm waves-effect waves-themed"
        }, "DECLINE")
      ])
    ])
  ])
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger shadow-0 bootbox-accept"
  }, " Yes"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-default bootbox-cancel"
  }, " No ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-500" }, "Success!", -1)
const _hoisted_39 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!
  const _component_Mo_modal_n = _resolveComponent("Mo_modal_n")!
  const _component_Mo_modal_s = _resolveComponent("Mo_modal_s")!
  const _component_Mo_modal_left_s = _resolveComponent("Mo_modal_left_s")!
  const _component_Mo_modal_left_l = _resolveComponent("Mo_modal_left_l")!
  const _component_Mo_modal_left_n = _resolveComponent("Mo_modal_left_n")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_l表示 "),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal_n())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_n表示 "),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal_s())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_s表示 ")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal_left())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_left_l表示 "),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal_left_n())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_left_n表示 "),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal_left_s())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_left_s表示 ")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModal_alert())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_alert表示 "),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal_alert2())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " Mo_modal_alert2表示 ")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_l, { ref: "Mo_modal_l" }, {
      title: _withCtx(() => [
        _createTextVNode("モーダルのタイトル")
      ]),
      body: _withCtx(() => [
        _createTextVNode("モーダルのボディの内容")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeModal())),
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal"
        }, " Close "),
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save())),
          type: "button",
          class: "btn btn-primary waves-effect waves-themed"
        }, " Save changes ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_n, { ref: "Mo_modal_n" }, {
      title: _withCtx(() => [
        _createTextVNode("モーダルのタイトル")
      ]),
      body: _withCtx(() => [
        _createTextVNode("モーダルのボディの内容")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeModal_n())),
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal"
        }, " Close "),
        _createElementVNode("button", {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save_n())),
          type: "button",
          class: "btn btn-primary waves-effect waves-themed"
        }, " Save changes ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_s, { ref: "Mo_modal_s" }, {
      title: _withCtx(() => [
        _createTextVNode("モーダルのタイトル")
      ]),
      body: _withCtx(() => [
        _createTextVNode("モーダルのボディの内容")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeModal_s())),
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal"
        }, " Close "),
        _createElementVNode("button", {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.save_s())),
          type: "button",
          class: "btn btn-primary waves-effect waves-themed"
        }, " Save changes ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_left_s, { ref: "Mo_modal_left_s" }, {
      title: _withCtx(() => [
        _createTextVNode("左モーダルのタイトル")
      ]),
      body: _withCtx(() => [
        _createTextVNode("モーダルのボディの内容")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeModal_left_s())),
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal"
        }, " Close "),
        _createElementVNode("button", {
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.save_left_s())),
          type: "button",
          class: "btn btn-primary waves-effect waves-themed"
        }, " Save changes ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_left_l, { ref: "Mo_modal_left_l" }, {
      title: _withCtx(() => [
        _createTextVNode("モーダルのタイトル")
      ]),
      body: _withCtx(() => [
        _createTextVNode("モーダルのボディの内容")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeModal())),
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal"
        }, " Close "),
        _createElementVNode("button", {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save())),
          type: "button",
          class: "btn btn-primary waves-effect waves-themed"
        }, " Save changes ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_left_n, { ref: "Mo_modal_left_n" }, {
      title: _withCtx(() => [
        _createTextVNode("モーダルのタイトル")
      ]),
      body: _withCtx(() => [
        _hoisted_32,
        _hoisted_33,
        _hoisted_34
      ]),
      footer: _withCtx(() => []),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_alert" }, {
      title: _withCtx(() => [
        _hoisted_35,
        _createTextVNode("XXXXXXXを削除します。よろしいですか？ ")
      ]),
      body: _withCtx(() => [
        _createTextVNode("削除したデータは復旧できません")
      ]),
      footer: _withCtx(() => [
        _hoisted_36
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_alert2" }, {
      title: _withCtx(() => [
        _hoisted_37,
        _hoisted_38
      ]),
      body: _withCtx(() => [
        _createTextVNode("削除しました")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("button", {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeModal_alert2())),
            type: "button",
            class: "btn btn-primary shadow-0 bootbox-accept"
          }, " Yes ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}